import { render, staticRenderFns } from "./pca.vue?vue&type=template&id=af2b13ba&scoped=true"
import script from "./pca.vue?vue&type=script&lang=js"
export * from "./pca.vue?vue&type=script&lang=js"
import style0 from "./pca.vue?vue&type=style&index=0&id=af2b13ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___2141a494b913d03a9170cbed536032b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2b13ba",
  null
  
)

export default component.exports